






























import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { requiredString } from "@/tool/validation";
import { VForm } from "@/common/vuetify_types";
import { Company } from "@/api";

@Component
export default class EditPopUpTextField extends Vue {
  @Ref("form") form!: VForm;
  @Prop() value!: string;
  @Prop() label!: string;
  @Prop() title!: string;
  @Prop() loading!: boolean;
  @Prop() company!: Company;
  requiredTextInput = [requiredString];
  editValue = JSON.parse(JSON.stringify(this.value || ""));

  close() {
    this.$emit("close");
  }

  save() {
    if (this.form.validate()) {
      const updateCompany = JSON.parse(JSON.stringify(this.company)) as Company;
      updateCompany.name = this.editValue;
      this.$emit("save", updateCompany);
    }
  }
}
